import Loading from "components/loading";
import NotFound from "components/notFound";
import { Suspense, lazy } from "react";
import { Route, Routes } from "react-router-dom";

const AuthPage = lazy(() => import("pages/auth"));

const RoutesMap = () => {
  return (
    <Suspense fallback={<Loading $centered />}>
      <Routes>
        <Route path="/*" element={<AuthPage />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Suspense>
  );
};

export default RoutesMap;
